import { gql } from '@apollo/client';
import carPrice from './fragments/carPrice';
import price from './fragments/price';

const variants = {
  GET_VARIANTS: gql`
    ${carPrice.CAR_PRICE}
    ${price.PRICE}
    query GetVariants(
      $trimCode: TrimCode!
      $filters: Filters
      $financeFormInput: FinanceFormInput
      $financeInput: FinanceInput
      $financeProductId: FinanceProductId
      $postCode: String
    ) {
      trim(trimCode: $trimCode) {
        attributes {
          label
        }
      }
      trimLevelVariants(filters: $filters, financeInput: $financeInput, postCode: $postCode) {
        marketingCategories @client
        financeFormInput @client
        variants {
          carConfig(financeProductId: $financeProductId, financeInput: $financeInput, postCode: $postCode) {
            car {
              code
            }
            prices {
              carPrice {
                ...CarPrice
              }
              totalFeatures {
                ...Price
              }
              totalConfiguration {
                ...Price
              }
              totalPrice {
                ...Price
              }
            }
            finance(financeFormInput: $financeFormInput) {
              type
              simulation {
                paymentValue {
                  currency
                  amount
                }
                comparisonRate
                frequency
              }
            }
          }
          variant {
            code
            attributes {
              marketingCategory
              name
              fuelType
              modelName
              fullSpecsUrl
              transmissionType
              transmission
              engine
              keyFeatures {
                description
                disclaimer
              }
            }
            image {
              type
              url
            }
          }
        }
      }
    }
  `,
};

export default variants;
